var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    [
      _c(
        "div",
        {
          directives: [{ name: "css-parallax", rawName: "v-css-parallax" }],
          staticClass: "parallax-wrapper",
        },
        [
          _c("div", {
            staticClass: "parallax-bg",
            style: "background-image: url(" + _vm.curr.cover + ")",
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "parallax container-xxl",
            style: "background-image: url(" + _vm.curr.cover + ")",
          }),
          _vm._v(" "),
          _c("div", { staticClass: "heading-bg" }, [
            _c("div", { staticClass: "container-sm" }, [
              _c("h1", { domProps: { textContent: _vm._s(_vm.curr.title) } }),
              _vm._v(" "),
              _c("div", {
                domProps: { textContent: _vm._s(_vm.curr.summary) },
              }),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "page-content container-sm" }, [
        _c("section", {
          staticClass: "py-3",
          domProps: { innerHTML: _vm._s(_vm.curr.content) },
        }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "bg-dark shadow mt-3" }, [
          _c("div", { ref: "sc", staticClass: "swiper-container faded" }, [
            _c(
              "div",
              { staticClass: "swiper-wrapper" },
              _vm._l(_vm.imgs, function (img, idx) {
                return _c(
                  "div",
                  {
                    staticClass: "swiper-slide w-auto",
                    on: {
                      click: function ($event) {
                        return _vm.slideTo(idx)
                      },
                    },
                  },
                  [_c("img", { attrs: { src: img + "!mh.288", alt: "img" } })]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.active !== 0,
                  expression: "active !== 0",
                },
              ],
              staticClass: "swiper-button-prev",
              on: { click: _vm.slidePrev },
            }),
            _vm._v(" "),
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.active !== _vm.imgs.length - 1,
                  expression: "active !== imgs.length - 1",
                },
              ],
              staticClass: "swiper-button-next",
              on: { click: _vm.slideNext },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "swiper-pagination" }),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "navigator font-sm py-5" },
          [
            _vm.prev
              ? _c(
                  "router-link",
                  { attrs: { to: `/project/${_vm.prev.id}?dir=right` } },
                  [
                    _c("i", {
                      staticClass: "iconfont icon-dot-arrow-left mr-1",
                    }),
                    _vm._v(" "),
                    _c("b", [_vm._v("上一个作品")]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "router-link",
              { staticClass: "mx-4", attrs: { to: "/projects" } },
              [_c("i", { staticClass: "iconfont icon-grid" })]
            ),
            _vm._v(" "),
            _vm.next
              ? _c(
                  "router-link",
                  { attrs: { to: `/project/${_vm.next.id}?dir=left` } },
                  [
                    _c("b", [_vm._v("下一个作品")]),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "iconfont icon-dot-arrow-right ml-1",
                    }),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("LightBox", {
        attrs: { img: _vm.img },
        on: {
          close: function ($event) {
            _vm.img = null
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pointing", attrs: { hidden: "" } }, [
      _c("i", { staticClass: "iconfont icon-dot-arrow-down font-lg" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }